import { ref, computed } from 'vue';
import { SecureStorage } from '@/utils/secureStorage';
import {
  LayoutDashboard, Settings, Bell, Lock, ShieldAlert,
  MessageSquare, Bot, Sparkles, Workflow, Zap,
  ShoppingBag, Tag, Image as ImageIcon, Box,
  Terminal, Server, Users, Activity, Database, QrCode, BrainCircuit,
  DollarSign,
  Receipt
} from 'lucide-vue-next';

// 1. EL OBJETO CRUDO CON LOS PERMISOS (allowedRoles)
const RAW_MODULES = {
  client_workspace: {
    id: 'client_workspace',
    name: 'Neurals Workspace',
    icon: Sparkles,
    color: 'text-indigo-500',
    bg: 'bg-indigo-500',
    allowedRoles: [1, 3], // Admin y Cliente
    menu: [
      { label: 'Tablero Principal', route: '/client/dashboard', icon: LayoutDashboard, active: true },
      { type: 'divider', label: 'Inteligencia Artificial' },
      { label: 'Conversaciones (Inbox)', route: '/client/conversations', icon: MessageSquare, active: false },
      { label: 'Instancias', route: '/client/instances', icon: QrCode, active: false },
      { label: 'Mis Agentes', route: '/client/agents', icon: BrainCircuit, active: false },
      //{ label: 'Flujos Automatizados', route: '/client/workflows', icon: Workflow, active: false },
      { label: 'Leads', route: '/client/leads', icon: Users, active: false },
      { label: 'Mis Productos', route: '/client/products', icon: ShoppingBag, active: false },
      { type: 'divider', label: 'Configuración' },
      { label: 'Facturacion', route: '/client/billing', icon: Receipt, active: false },
      /* { label: 'Precios y Descuentos', route: '/client/pricing', icon: Tag, active: false },
      { label: 'Galería de Fotos', route: '/client/gallery', icon: ImageIcon, active: false },
      { type: 'divider', label: 'Configuración' },
      { label: 'Ajustes del Negocio', route: '/client/settings', icon: Settings, active: false } */
    ]
  },
  admin_goat: {
    id: 'admin_goat',
    name: 'Admin Control',
    icon: ShieldAlert,
    color: 'text-emerald-500',
    bg: 'bg-emerald-500',
    allowedRoles: [1], // SOLO Admin
    menu: [
      { label: 'Métricas Globales (SaaS)', route: '/settings/metrics', icon: Activity, active: false },
      { label: 'Gestión de Inquilinos (Clientes)', route: '/settings/users', icon: Users, active: false },
      { label: 'Planes y Precios', route: '/settings/plans', icon: DollarSign, active: false },
      { label: 'Facturas y Cobros', route: '/settings/billing', icon: DollarSign, active: false },
      { type: 'divider', label: 'Infraestructura' },
      { label: 'Instancias Evolution API', route: '/admin/evolution', icon: Zap, active: false },
      { label: 'Base de Datos (Estado)', route: '/admin/database', icon: Database, active: false },
      { label: 'Servidores & Nodos', route: '/admin/servers', icon: Server, active: false },
      { type: 'divider', label: 'Seguridad' },
      { label: 'Logs del Sistema', route: '/admin/logs', icon: Terminal, active: false },
      { label: 'Auditoría y Accesos', route: '/admin/audit', icon: Lock, active: false }
    ]
  }
};

// Variables reactivas globales (estado compartido)
const currentModule = ref(null);
const modulesList = ref({});

export function useAppModules() {
  // 2. FILTRADO AUTOMÁTICO BASADO EN EL ROL AL INICIALIZAR
  if (Object.keys(modulesList.value).length === 0) {
    const user = SecureStorage.getItem('neurals_user') || SecureStorage.getItem('llevo_user');
    const userRole = user?.role_id || 3; // Por defecto asumimos 3 (Cliente) por seguridad

    const filtered = {};
    for (const key in RAW_MODULES) {
      if (RAW_MODULES[key].allowedRoles.includes(userRole)) {
        filtered[key] = RAW_MODULES[key];
      }
    }

    modulesList.value = filtered;

    // Asignar módulo por defecto si no hay ninguno
    if (!currentModule.value) {
      currentModule.value = filtered['client_workspace'] || Object.values(filtered)[0];
    }
  }

  const currentMenu = computed(() => {
    return currentModule.value ? currentModule.value.menu : [];
  });

  const switchModule = (moduleId) => {
    if (modulesList.value[moduleId]) {
      currentModule.value = modulesList.value[moduleId];
    }
  };

  return {
    modulesList,
    currentModule,
    currentMenu,
    switchModule
  };
}